import { apiGet } from './_common';

export default {
  getById(id) {
    return apiGet(`/magenta/admin/${id}`)
      .then(result => result.response);
  },
};
